"use client";

import { createBrowserClient } from "@supabase/ssr";
import {
  ENV,
  RUNTIME,
  SITE_URL,
  SITE_URL_NETWORK,
  SUPABASE_PUBLISHABLE_KEY,
  SUPABASE_URL,
} from "@/constants";
import { EnvironmentEnum, RuntimeEnum } from "@/enums";
import type { Database, TypedSupabaseClient } from "@/types";
import { getSafeOriginFromWindow } from "@/utils/origin";

export function resolveSupabaseClientUrl(): string {
  const currentOrigin =
    RUNTIME === RuntimeEnum.CLIENT ? getSafeOriginFromWindow() : undefined;
  const IS_DEV_SERVER =
    ENV === EnvironmentEnum.DEVELOPMENT &&
    RUNTIME === RuntimeEnum.CLIENT &&
    (currentOrigin === SITE_URL ||
      (SITE_URL_NETWORK !== undefined && currentOrigin === SITE_URL_NETWORK));
  return IS_DEV_SERVER && currentOrigin ? currentOrigin : SUPABASE_URL;
}

export function resolveFunctionsUrl(name: string): string {
  return `${resolveSupabaseClientUrl()}/functions/v1/${name}`;
}

let client: TypedSupabaseClient | undefined;
export function createClient(): TypedSupabaseClient {
  if (!client) {
    client = createBrowserClient<Database>(
      resolveSupabaseClientUrl(),
      SUPABASE_PUBLISHABLE_KEY,
    );
  }
  return client;
}
